import api from "../api/CustomerApi";

export const DeliveryAddressServices = {
  getAddress: async () => {
    const res = await api.get("/delivery-address");
    return res.data;
  },

  addAddress: async (payload) => {
    const res = await api.post("/delivery-address", payload);
    return res.data;
  },

  updateAddress: async (id, payload) => {
    const res = await api.put(`/delivery-address/${id}`, payload);
    return res.data;
  },
};

export default DeliveryAddressServices;